<template>
  <div data-qa="invasive_service_info">
    <RequiresPrimaryConsultationModal />
    <ReferralForServiceModal />
  </div>
</template>

<script lang="ts" setup>
import { onBeforeUnmount } from 'vue'
import useInvasiveServiceInfoStore from 'src/components/common/InvasiveServiceInfo/stores/useInvasiveServiceInfoStore'
import RequiresPrimaryConsultationModal from 'src/components/common/InvasiveServiceInfo/components/RequiresPrimaryConsultationModal.vue'
import ReferralForServiceModal from 'src/components/common/InvasiveServiceInfo/components/ReferralForServiceModal.vue'

const invasiveServiceInfoStore = useInvasiveServiceInfoStore()

invasiveServiceInfoStore.isCreatedComponent = true

onBeforeUnmount(() => {
  invasiveServiceInfoStore.isCreatedComponent = false
})
</script>
